import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);

Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/login', component: _import('page/login'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/noPermission', component: _import('page/nopermission'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/auth', component: _import('page/auth'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/logout', component: _import('page/logout'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/401', component: _import('page/401'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/404', component: _import('page/404'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/500', component: _import('page/404'), hidden: true,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' }
  },
  {
    path: '/flypigvalidate', name: '卡券验证', component: _import('flypig/fly_pig_validatel'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '卡券验证' },
  },
  {
    path: '/flypigdetail', name: '优惠购买', component: _import('flypig/fly_pig_detail'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '优惠购买' },
  },
  {
    path: '/flypigorder', name: '订单详情', component: _import('flypig/fly_pig_order'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '订单详情' },
  },
];

export const asyncRouterMap = [
  {
    path: '/', name: '根目录', redirect: '/index', component: _import('page/login'), hidden: false,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/protocol://backtoapp', name: 'back', redirect: '/index', component: _import('page/login'), hidden: false,
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/index', name: '首页', icon: 'true', component: _import('home/index'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/activity190618', name: '活动页', icon: 'true', component: _import('home/activity0618'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/activity190617', name: '活动页', icon: 'true', component: _import('home/activity0617'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/search', name: '搜索', icon: 'fa fa-search', component: _import('home/search'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/category', name: '分类', icon: 'fa fa-search', component: _import('home/category'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/detail', name: '商品详情', icon: 'fa fa-search', component: _import('product/detail'),
    meta: { role: ['default', 'moc'], allowBack: false, title: 'moc' },
  },
  {
    path: '/cashier', name: '收银台', icon: 'fa fa-search', component: _import('order/cashier'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/redirect', name: '在线支付', icon: 'fa fa-search', component: _import('order/redirect'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/aliMiddle', name: '微信中打开支付宝中转页', icon: 'fa fa-search', component: _import('order/aliMiddle'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/result/:orderId?', name: '支付结果页', icon: 'fa fa-search', component: _import('order/result'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/user', name: '我的', icon: 'fa fa-search', component: _import('member/user'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/order_list', name: '订单', icon: 'fa fa-search', component: _import('order/order_list'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/order_list_01', name: '订单', icon: 'fa fa-search', component: _import('order/order_list_01'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/order_detail', name: '订单详情', icon: 'fa fa-search', component: _import('order/order_detail'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  {
    path: '/customer', name: '我的客服', icon: 'fa fa-search', component: _import('member/customer'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '佳之易充值中心' },
  },
  { path: '*', redirect: '/404', hidden: true },
];


export const asyncRouterMapTFT = [
  {
    path: '/', name: '根目录', redirect: '/index', component: _import('page/login'), hidden: false,
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/protocol://backtoapp', name: 'fa', redirect: '/index', component: _import('page/login'), hidden: false,
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/index', name: '天府通', icon: 'fa', component: _import('TFT/index'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/TX_index', name: '天府通腾讯VIP', icon: 'fa', component: _import('TFT/TX_index'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/YK_index', name: '天府通优酷VIP', icon: 'fa', component: _import('TFT/YK_index'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/detail', name: '商品详情', icon: 'fa', component: _import('TFT/detail'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/result/:orderId?', name: '支付结果页', icon: 'fa', component: _import('order/result'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/user', name: '我的', icon: 'fa', redirect: '/index', component: _import('member/user'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/order_list', name: '订单', icon: 'fa', redirect: '/index', component: _import('order/order_list'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/order_detail', name: '订单详情', icon: 'fa', redirect: '/index', component: _import('order/order_detail'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  {
    path: '/cashier', name: '收银台', icon: 'fa', redirect: '/index', component: _import('order/cashier'),
    meta: { role: ['default', 'moc'], allowBack: false, title: '' },
  },
  {
    path: '/customer', name: '我的客服', icon: 'fa', component: _import('member/customer'),
    meta: { role: ['tft'], allowBack: false, title: '' },
  },
  // {path: '*', redirect: '/404', hidden: true}
];


export default new Router({
  mode: 'history',
  // mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
  // routes: asyncRouterMap.concat(constantRouterMap)
});



// WEBPACK FOOTER //
// ./src/router/index.js